

























import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import * as api from '@/api';
import * as models from '@/api/models';
import { Toast } from 'vant';
@Component({
  components: {},
})
export default class LeaveList extends Vue {
  loading: boolean = false;
  finished: boolean = false;
  list: any = [];
  currentPage: number = 1;
  onLoad() {
    // 异步更新数据
    // setTimeout 仅做示例，真实场景中一般为 ajax 请求
    setTimeout(() => {
      for (let i = 0; i < 5; i++) {
        this.list.push(this.list.length + 1);
      }

      // 加载状态结束
      this.loading = false;

      // 数据全部加载完成
      if (this.list.length >= 5) {
        this.finished = true;
      }
    }, 1000);
  }
  onClickLeft() {
    this.$router.go(-1);
  }
}
